import { render } from "./CollectionsListPopular.vue?vue&type=template&id=3e0b5f20"
import script from "./CollectionsListPopular.vue?vue&type=script&lang=js"
export * from "./CollectionsListPopular.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__